import { useEffect, useRef, useState } from "react";
import Axios from "axios";
import { URL_LIST_ALL } from "../configs/api";
import { useSelector } from "react-redux";
import PostItem from "./PostItem";
import CreatePost from "./CreatePost";
import { checkRole } from "../model";
import "../assets/css/PostsComment.css";
import { Modal } from "react-bootstrap";
import Spinner from "../component/Spinner";

import PostHeader from "./PostHeader";

export default function PostsList({ alias,postId,listGroup }) {
  const { user } = useSelector((state) => state.auth);
  const { savePosts } = useSelector((state) => state.save);

  const [listPost, setListPost] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [postSelect, setPostSelect] = useState(null);

  const [modalSearch, setModalSearch] = useState(false);
  const [keySearch, setKeySearch] = useState('');
  const [searchLoading, setSearchLoading] = useState(false)
  const [searchResult, setSearchResult] = useState([])

  const postListRef = useRef(null);

  useEffect(() => {
    fetchPosts();
  }, []);

  useEffect(() => {
    if (!postListRef.current) return;
    const el = postListRef.current;

    const handleScroll = () => {
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 100) {
        fetchPosts();
      }
    };
    el.addEventListener("scroll", handleScroll);
    return () => el.removeEventListener("scroll", handleScroll);
  }, [loading, hasMore]);

  useEffect(() => {
    if (savePosts) {
      setListPost((prev) => {
        const existsIndex = prev.findIndex((post) => post.id === savePosts.id);
        if (existsIndex !== -1) {
          const postChanged = prev[existsIndex];
          const isChanged =
            postChanged.post_content !== savePosts.post_content ||
            postChanged.status !== savePosts.status ||
            postChanged.getComment !== savePosts.getComment ||
            postChanged.pin !== savePosts.pin ||
            savePosts.onchange;

          if (isChanged) {
            const updatedPosts = [...prev];
            updatedPosts[existsIndex] = savePosts;
            return updatedPosts;
          }
          return prev;
        } else {
          return [savePosts, ...prev];
        }
      });
    }
  }, [savePosts]);

  const fetchPosts = async () => {
    if (loading || !hasMore) return;
    setLoading(true);
    try {
      const { data } = await Axios.get(
        `${URL_LIST_ALL}posts?limit=5&page=${page}&orderby=id-desc${alias ? `&group-alias=${alias}` : ""}${postId ? `&id=${postId}` : ''}`,
        user.config
      );
      if (data.status === "success") {
        setListPost((prev) => {
          const updated = [...prev];
          data.data.forEach((newPost) => {
            const index = updated.findIndex((p) => p.id === newPost.id);
            if (index !== -1) updated[index] = newPost;
            else updated.push(newPost);
          });
          return updated;
        });
        setHasMore(data.data.length === 5);
        setPage((prev) => prev + 1);
        setModalSearch(false)
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  
  const handlePinPost = (pinnedPostId) => {
    setListPost((prev) => {
      return prev.map((post) => ({
        ...post,
        pin: post.id === pinnedPostId ? 1 : 0
      })).sort((a, b) => {
        // Bài ghim lên đầu
        if (a.pin !== b.pin) return b.pin - a.pin;
        // Sắp xếp theo id mới nhất
        return b.id - a.id;
      });
    });
  };

  const startSearch = async () => {
    if (keySearch && keySearch != '') {
      setSearchResult([]);
      setSearchLoading(true)
      const { data } = await Axios.get(
        `${URL_LIST_ALL}posts?limit=10000&orderby=id-desc${keySearch ? `&post_content=${keySearch}` : ""}`,
        user.config
      );

      if (data.status === "success") {
        // if (data.list_group) setListGroup(data.list_group);
        setSearchResult(data.data);
        setSearchLoading(false)
      } else {
        setSearchLoading(false)
      }
    }
  }

  const linkify = (html) =>
    html.replace(
      /(?<!src="|href="|">)(https?:\/\/[^\s<]+)/g,
      '<a href="$1" class="text-danger" target="_blank" rel="noopener noreferrer">$1</a>'
    );

  return (
    <>
      {/* Danh sách bài đăng */}
      <div className="post-list" ref={postListRef}>
        <div className="w-100 d-flex justify-content-center">
          <div className="posts-container">
            {checkRole(user, "posts", "") && (
              <div className="w-100 mb-3">
                <CreatePost onPostCreated={() => setHasMore(true)} listGroup={listGroup} />
              </div>
            )}

            <div className="w-100 section-list-post mt-3">
              {listPost.map((post) =>
                post.status === 1 || post.status === 3 ? (
                  <div key={post.id} className="post-item shadow-sm bg-white">
                    {post.pin == 1 && !alias && !postId ?
                      <>
                        <PostHeader data={post} />
                        <h5 className="text-primary w-100 text-center"><strong>Đã ghim một bài viết</strong> <span className="	fas fa-angle-double-down"></span></h5>
                        <div className="w-100 mt-2 post-content post-pin" onClick={() => { setShowModal(true); setPostSelect(post); }} dangerouslySetInnerHTML={{ __html: linkify(post.post_content) }} />
                        <div className="w-100 d-flex justify-content-center">
                          <button type="button" className="mt-2 viewmore text-danger" onClick={() => { setShowModal(true); setPostSelect(post); }}>
                            <strong>Xem chi tiết...</strong>
                          </button>
                        </div>
                      </>
                      :
                      <>
                        <PostItem post={post} viewmore={postId ? true : false} listGroup={listGroup} onShowPost={() => { setShowModal(true); setPostSelect(post); }} onPinPost={handlePinPost} />
                        {!postId && post.getComment && post.getComment.length > 2 && (
                          <div className="w-100 d-flex justify-content-center">
                            <button type="button" className="mt-2 viewmore" onClick={() => { setShowModal(true); setPostSelect(post); }}>
                              Xem thêm bình luận...
                            </button>
                          </div>
                        )}
                      </>
                    }
                    {postId && <div className="col-12 pt-5 pb-5"></div>}
                  </div>
                ) : null
              )}
            </div>

            {loading && <div className="text-center p-2">Đang tải...</div>}
            {!hasMore && <div className="text-center text-muted">Hết bài viết</div>}

          </div>
        </div>

        {/* Modal bài viết chi tiết */}
        <Modal show={showModal} className="modal-thread" onHide={() => setShowModal(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Bài đăng trên cộng đồng Blue</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {postSelect && (
              <div className="post-item">
                <PostItem post={postSelect} viewmore listGroup={listGroup} />
              </div>
            )}
          </Modal.Body>
        </Modal>

       
        <Modal show={modalSearch} className="modal-thread" onHide={() => setModalSearch(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Tìm kiếm trong Cộng đồng</Modal.Title>
          </Modal.Header>
          <Modal.Body className="bg-ash">
            <div className="w-100 form-group">
              <label>Nhập từ khóa tìm kiếm <span className="text-danger">*</span></label>
              <input
                type="text"
                placeholder="VD: Nội bộ BHS"
                className="form-control height32"
                value={keySearch}
                onChange={(e) => setKeySearch(e.target.value)}
                autoComplete="off"
              />
            </div>
            <div className="w-100 form-group">
              <button type="button" className="btn btn-sm btn-success" onClick={startSearch} disabled={searchLoading}>
                {searchLoading ? <Spinner /> : "Tìm kiếm"}
              </button>
            </div>

            {searchResult && searchResult.length > 0 ?
              <div className="w-100 section-list-post mt-3">
                <h4>Kết quả tìm kiếm cho từ khóa: "{keySearch}"</h4>
                <hr />
                {searchResult.map((post) =>
                  post.status === 1 || post.status === 3 ? (
                    <div key={post.id} className="post-item shadow-sm bg-white">
                      <PostItem post={post} viewmore={false} listGroup={listGroup} onShowPost={() => { setShowModal(true); setPostSelect(post); }} onPinPost={handlePinPost} />
                      {post.getComment && post.getComment.length > 2 && (
                        <div className="w-100 d-flex justify-content-center">
                          <button type="button" className="mt-2 viewmore" onClick={() => { setShowModal(true); setPostSelect(post); }}>
                            Xem thêm bình luận...
                          </button>
                        </div>
                      )}
                    </div>
                  ) : null
                )}
              </div>
              : ''}
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}
